module.exports = __webpack_public_path__ + "img/CBD-Gummies.a1aa460c.png";